<app-nav-bar></app-nav-bar>
<div class="container terms-condition23">
  <div class="terms-condation-content">
    <h1 class="text-center"><strong>Terms & conditions</strong></h1>
    <article>
      <h3><strong>Introduction</strong></h3>
      <p>
        TheQuan.com (“TheQuan.com”) respects your privacy and is committed to
        protecting it through our compliance with this policy. This policy
        describes:
      </p>
      <ul>
        <li>
          The types of information we may collect or that you may provide when
          you download, install, use, and/or access the TheQuran.com App (the
          “App”) along with any other website associated with the App and
          TheQuan.com website, however accessed (collectively, the “Service”).
        </li>
        <li>
          Our practices for collecting, using, maintaining, protecting and
          disclosing that information.
        </li>
      </ul>
      <p>
        This policy applies only to information we collect in the Service in
        e-mail, text, uploads, and other electronic communications sent through
        or in connection with the Service.
      </p>
      <p>This policy DOES NOT apply to information that:</p>
      <ul>
        <li>We collect offline; or</li>
        <li>You provide to or is collected by any third party;</li>
      </ul>
      <p>
        These third parties may have their own privacy policies, which we
        encourage you to read before providing information on or through them.
      </p>
      <p>
        Please read this policy carefully to understand our policies and
        practices regarding your information and how we will treat it. If you do
        not agree with our policies and practices, do not download, register
        with or use the Service. By downloading, installing, using, and/or
        accessing the Service, you agree to this privacy policy. This policy may
        change from time to time. Your continued use of the Service after we
        make changes is deemed to be acceptance of those changes, so please
        check the policy periodically for updates.
      </p>
    </article>

    <article>
      <h3><strong>Children under the Age of 18</strong></h3>
      <p>
        The App is not intended for children under 18 years of age, and we do
        not knowingly collect personal information from children under 18. If
        you believe we might have any information from or about a child under
        18, please contact us at:
        <a href="mailto:admin@thequran.com">admin@thequran.com</a>
      </p>
    </article>

    <article>
      <h3><strong>Information We Collect and How We Collect It</strong></h3>
      <p>We collect information from and about users of our Service:</p>
      <ul>
        <li>Directly from you when you provide it to us.</li>
        <li>Automatically when you use the Service.</li>
      </ul>
    </article>

    <article>
      <h3><strong>Information You Provide to Us.</strong></h3>
      <p>
        When you download, install, use, and/or access the Service, we may ask
        you provide information:
      </p>
      <ul>
        <li>
          By which you may be personally identified, such as name, postal
          address, e-mail address, telephone number, GPS coordinates and any
          other identifier by which you may be contacted online or offline
          (”personal information”).
        </li>
        <li>
          That is about you but individually does not identify you. This
          information includes:
        </li>
        <li>
          Information that you provide by filling in forms in the Service. This
          includes information provided at the time of registering to use the
          Service and posting material. We may also ask you for information when
          you report a problem with the Service.
        </li>
        <li>
          Records and copies of your correspondence (including e-mail addresses
          and phone numbers) if you contact us.
        </li>
        <li>
          Your responses to surveys that we might ask you to complete for
          research purposes.
        </li>
        <li>
          Details of transactions you carry out through the Service. You may be
          required to provide financial information depending on how you use the
          Service.
        </li>
        <li>Your search queries on the Service.</li>
      </ul>
      <p>
        You may provide information to be published or displayed (” Posted”) on
        public areas of websites you access through the Service (collectively,
        “User Contributions”). Your User Contributions are Posted and
        transmitted to others at your own risk. Please be aware that by Posting
        User Contributions, your User Contributions may be viewed by any other
        users of the Service and potentially non-users, should such User
        Contributions become published by a media outlet.
      </p>
    </article>

    <article>
      <h3><strong>Automatic Information Collection and Tracking.</strong></h3>
      <p>
        When you download, install, use, and/or access the Service, it may use
        technology to automatically collect:
      </p>
      <ul>
        <li>
          Usage Details. When you access and use the Service, we may
          automatically collect certain details of your access to and use of the
          Service, including traffic data, location data, GPS coordinates, logs
          and other communication data and the resources that you access and use
          on or through the Service.
        </li>
        <li>
          Device Information. We may collect information about your mobile
          device and internet connection, including the device’s unique device
          identifier, IP address, operating system, browser type, mobile network
          information and the device’s telephone number.
        </li>
        <li>
          Stored Information and Files. The Service also may access metadata and
          other information associated with other files stored on your device.
          This may include, for example, photographs, audio and video clips,
          personal contacts and address book information.
        </li>
        <li>
          Location Information. This Service collects real-time information
          about the location of your device.
        </li>
      </ul>
      <p>
        If you do not want us to collect this information do not download,
        install, use, and/or access the Service or delete it from your device.
      </p>
    </article>

    <article>
      <h3>
        <strong>Information Collection and Tracking Technologies.</strong>
      </h3>
      <p>
        The technologies we use for automatic information collection may
        include:
      </p>
      <ul>
        <li>
          Cookies (or mobile cookies). A cookie is a small file placed on your
          device. It may be possible to refuse to accept cookies by activating
          the appropriate setting on your device. However, if you select this
          setting you may be unable to access certain parts of our Service.
        </li>
        <li>
          Web Beacons. Pages of the Service and our e-mails may contain small
          electronic files known as web beacons (also referred to as clear gifs,
          pixel tags and single-pixel gifs) that permit TheQuan.com , for
          example, to count users who have visited those pages or opened an
          e-mail and for other related Service statistics (for example,
          recording the popularity of certain app content and verifying system
          and server integrity).
        </li>
      </ul>
    </article>

    <article>
      <h3><strong>Third-party Information Collection</strong></h3>
      <p>
        When you use the Service or its content, certain third parties may use
        automatic information collection technologies to collect information
        about you or your device. These third parties may include:
      </p>
      <ul>
        <li>Advertisers, ad networks and ad servers.</li>
        <li>Analytics companies.</li>
        <li>Your mobile device manufacturer.</li>
        <li>Your mobile service provider.</li>
        <li>Your internet service provider.</li>
      </ul>
      <p>
        We do not control these third parties’ tracking technologies or how they
        may be used. If you have any questions about an advertisement or other
        targeted content, you should contact the responsible provider directly.
      </p>
    </article>

    <article>
      <h3><strong>How We Use Your Information</strong></h3>
      <p>
        We use information that we collect about you or that you provide to us,
        including any personal information, to:
      </p>
      <ul>
        <li>
          Provide you with the Service and its contents, and any other
          information, products or services that you request from us.
        </li>
        <li>Fulfill any other purpose for which you provide it.</li>
        <li>
          Carry out our obligations and enforce our rights arising from any
          contracts entered into between you and us.
        </li>
        <li>
          Notify you when Service updates are available, and of changes to any
          products or services we offer or provide though it.
        </li>
      </ul>
      <p>
        The usage information we collect helps us to improve our Service and to
        deliver a better and more personalized experience by enabling us to:
      </p>
      <ul>
        <li>Estimate our audience size and usage patterns.</li>
        <li>
          Store information about your preferences, allowing us to customize our
          Service according to your individual interests.
        </li>
        <li>Speed up your searches.</li>
        <li>Recognize you when you use the Service.</li>
      </ul>
      <p>
        We may use location information we collect to allow other Service Users
        and media outlets to identify the location of relevant posted media as
        to allow a smoother experience for getting information about current
        events. We may disclose your location to Media Outlets if you allow us
        to on the App, and we may disclose the location of the User Contribution
        to anyone.
      </p>
      <p>
        We may also use your information to contact you should any of your User
        Contributions be sold by a media outlet. For more information, please
        see our End User License Agreement (“EULA”).
      </p>
      <p>
        We may use the information we collect to display advertisements to our
        advertisers’ target audiences. Even though we do not disclose your
        personal information for these purposes without your consent, if you
        click on or otherwise interact with an advertisement, the advertiser may
        assume that you meet its target criteria.
      </p>
    </article>

    <article>
      <h2><strong>Disclosure of Your Information</strong></h2>
      <p>
        We may disclose aggregated information about our users, and information
        that does not identify any individual or device, without restriction.
      </p>
      <p>
        In addition, we may disclose personal information that we collect, or
        you provide:
      </p>
      <ul>
        <li>To our subsidiary, parent, and affiliate companies.</li>
        <li>
          To contractors, service providers and other third parties we use to
          support our business and who are bound by contractual obligations to
          keep personal information confidential and use it only for the
          purposes for which we disclose it to them.
        </li>
        <li>
          To a buyer or other successor in the event of a merger, divestiture,
          restructuring, reorganization, dissolution or other sale or transfer
          of some or all of TheQuan.com ’s assets, whether as a going concern or
          as part of bankruptcy, liquidation or similar proceeding, in which
          personal information held by TheQuan.com about our Service users is
          among the assets transferred.
        </li>
        <li>To fulfill the purpose for which you provide it.</li>
        <li>
          For any other purpose disclosed by us when you provide the
          information.
        </li>
        <li>With your consent.</li>
        <li>
          To comply with any court order, law, or legal process, including to
          respond to any government or regulatory request.
        </li>
        <li>
          To enforce our rights arising from any contracts entered between you
          and us, including the Service EULA.
        </li>
        <li>
          If we believe disclosure is necessary or appropriate to protect the
          rights, property, or safety of TheQuan.com, our customers or others.
          This includes exchanging information with other companies and
          organizations for the purposes of fraud protection and credit risk
          reduction.
        </li>
      </ul>
    </article>

    <article>
      <h2>
        <strong
          >Your Choices about Our Collection, Use and Disclosure of Your
          Information</strong
        >
      </h2>
      <p>
        We strive to provide you with choices regarding the personal information
        you provide to us. This section describes mechanisms we provide for you
        to control certain uses and disclosures of over your information
      </p>
      <ul>
        <li>
          Tracking Technologies. You can set your browser to refuse all or some
          browser cookies, or to alert you when cookies are being sent. You can
          choose whether or not to allow the Service to collect information
          through other tracking technologies by your device settings. If you
          disable or refuse cookies or block the use of other tracking
          technologies, some parts of the Service may then be inaccessible or
          not function properly.
        </li>
        <li>
          Location Information. You can choose whether or not to allow the App
          to collect and use real-time information about your device’s location
          through the device’s privacy settings. If you block the use of
          location information, some parts of the Service may then be
          inaccessible or not function properly.
        </li>
      </ul>
    </article>

    <article>
      <h2>
        <strong>Accessing and Correcting Your Personal Information</strong>
      </h2>
      <p>
        You can review and change your personal information by logging into the
        Service and visiting your account profile page.
      </p>
      <p>
        You may also send us an e-mail at info@mediatechnology.net to request
        access to, correct or delete any personal information that you have
        provided to us. We cannot delete your personal information except by
        also deleting your user account. We may not accommodate a request to
        change information if we believe the change would violate any law or
        legal requirement or cause the information to be incorrect.
      </p>
      <p>
        If you delete your User Contributions from the Service, copies of your
        User Contributions may remain viewable on the Service nonetheless or in
        cached and archived pages or might have been copied or stored by other
        Service users. Proper access and use of information provided on the
        Service, including User Contributions, is governed by our EULA.
      </p>
    </article>

    <article>
      <h2><strong>Data Security</strong></h2>
      <p>
        We have implemented measures designed to secure your personal
        information from accidental loss and from unauthorized access, use,
        alteration and disclosure. All information you provide to us is stored
        on our secure servers behind firewalls. Any payment transactions will be
        encrypted using SSL technology.
      </p>
      <p>
        The safety and security of your information also depends on you. Where
        we have given you (or where you have chosen) a password for access to
        certain parts of our Service, you are responsible for keeping this
        password confidential. We ask you not to share your password with
        anyone. We urge you to be careful about giving out information in public
        areas of the Service like the comment sections of User Contributions.
        The information you share in public areas may be viewed by any user of
        the Service.
      </p>
      <p>
        Unfortunately, the transmission of information via the Internet and
        mobile platforms is not completely secure. Although we do our best to
        protect your personal information, we cannot guarantee the security of
        your personal information transmitted through our Service. Any
        transmission of personal information is at your own risk. We are not
        responsible for circumvention of any privacy settings or security
        measures we provide.
      </p>
    </article>

    <article>
      <h2><strong>Changes to Our Privacy Policy</strong></h2>
      <p>
        We may update our privacy policy from time to time. If we make material
        changes to how we treat our users’ personal information, we will post
        the new privacy policy on this page with a notice that the privacy
        policy has been updated.
      </p>
      <p>
        The date the privacy policy was last revised is identified at the top of
        the page. You are responsible for ensuring we have an up-to-date active
        and deliverable e-mail address for you and for periodically visiting
        this privacy policy to check for any changes.
      </p>
    </article>

    <article>
      <h2><strong>Contact Information</strong></h2>
      <p>
        To ask questions or comment about this privacy policy and our privacy
        practices, contact us at:
      </p>
      <div><a href="mailto:admin@thequran.com">admin@thequran.com</a></div>
    </article>
  </div>
</div>
